import BaseController from "controllers/base"

import BookInspection       from "widgets/dashboard/bookInspection";
import ProjectSearchWidget  from "widgets/projectSearchWidget";

class Controller extends BaseController {
  call() {
    bindInspectionBooking.call(this)
    bindShowLinks.call(this)
    bindProjectSearchWidget.call(this)
  }
};

let bindProjectSearchWidget = function() {
  this.projectSearchWidget = new ProjectSearchWidget(this.root)
}


var bindInspectionBooking = function() {
  const modalEl = document.getElementById("inspection-booking-modal")
  if (modalEl && window.bootstrap && window.bootstrap.Modal) {
    this.root.off("click.dashboardInspectionBooking", ".js-open-inspection-booking-modal")
    this.root.on("click.dashboardInspectionBooking", ".js-open-inspection-booking-modal", (e) => {
      e.preventDefault()
      window.bootstrap.Modal.getOrCreateInstance(modalEl).show()
    })
  }

  try {
    this.bookInspection = new BookInspection(this.root.find("#inspection-booking-modal"))
    this.bookInspection.on("form-loaded", () => {
      this.bindInputComponents()
    })
  } catch (err) {
    if (typeof gon !== "undefined" && gon.env === "development") {
      // eslint-disable-next-line no-console
      console.error("[dashboard/BookInspection]", err)
    }
  }
}

let bindShowLinks = function() {
  this.root.on('click', '.project-item', (e) => {
    window.location = e.currentTarget.dataset.url
  })
}


export default Controller;
